import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { t } from 'translation'

const IndicationTypeItem = ({
  clickTreatment,
  title,
  index,
  indicationRef,
  isOnline,
  Icon,
  slider,
  slideIndex,
  activeSlide,
  sliderDotHandler,
}) => {
  return (
    <>
      {/* <li className="session_type_item">
      <button
        className="session_type_item_btn"
        ref={(btn) => (indicationRef.current[index] = btn)}
        onClick={() => clickTreatment()}
      >
        <figure className="session_type_item_graph">
          <figcaption className="session_type_item_info">
            <h3 className="session_type_item_title default_text">{title}</h3>
          </figcaption>
        </figure>
      </button>
    </li> */}
      <div className="indication_controls_item">
        <button
          className={`indication_controls_btn ${
            index == activeSlide ? 'active_mod' : ''
          }`}
          ref={(btn) => (indicationRef.current[index] = btn)}
          onClick={() => sliderDotHandler(index)}
        >
          <div className="indication_controls_icon">
            <Icon className="icon size_mod" />
          </div>
          <div className="indication_controls_title">{title}</div>
        </button>
      </div>
    </>
  )
}

const mapStateToProps = ({ auth: { isOnline } }) => ({ isOnline })

export default connect(mapStateToProps)(IndicationTypeItem)

// IndicationTypeItem.propTypes = {
//   clickTreatment: PropTypes.func.isRequired,
//   title: PropTypes.string.isRequired,
// }
